import { Component } from '@angular/core';

@Component({
  selector: 'fl-sticky-bottom',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./sticky-bottom.component.scss'],
})
export class StickyBottomComponent {}
